export default __webpack_public_path__ + "img/eyGQKiPP.e21ac270.svg";